import styled, { css } from 'styled-components';
import Spinner, { SpinnerSVG, SpinnerText } from '../../../components/spinner';
import Typography from '../../../components/typography';
import { stylePropertiesToCss } from '../../../design-tokens/style-mixins';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { ANWBDefault } from '../../../design-tokens/theme';
const SPINNER_SIZE = 30;
/**
 * TextArea Wrapper
 * @deprecated
 */
export const textAreaWrapperStyles = () => css `
	position: relative;
	width: 100%;
`;
/**
 * @deprecated
 */
export const TextAreaWrapper = styled.div `
	${textAreaWrapperStyles}
`;
/**
 * @deprecated
 */
export const textareaContainerStyles = ({ theme, $invalid, $loading, }) => css `
	width: 100%;
	height: auto;
	min-height: ${pxToRem(128)};
	padding: ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))}
		${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))} 0
		${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']))};
	border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.medium.borderFormField};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.blanc.bgFormField};
	overflow: auto;
	resize: vertical;
	background-image: none;
	appearance: none;

	&:focus {
		border-color: ${theme.colors.highlight.borderHover};
		outline: 0;
	}

	&:disabled {
		color: ${theme.colors.medium.textInactive};
		border-color: ${theme.colors.light.borderFormFieldDisabled};
		background-color: ${theme.colors.extralight.bgFormFieldDisabled};

		&::placeholder {
			color: ${theme.colors.medium.textInactive};
		}
	}

	&::placeholder {
		color: ${theme.colors.informative.textFormField};

		${stylePropertiesToCss(Object.assign(Object.assign({}, theme.typography.formFields['100FieldHintText']), { fontStyle: theme.name === ANWBDefault.name ? 'Italic' : 'Normal' }))}
	}

	&:valid,
	&:invalid {
		box-shadow: none;
	}

	${$invalid &&
    css `
		:not(:disabled) {
			border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.error.borderFormField};

			&:focus {
				border-color: ${theme.colors.highlight.borderHover};
				outline: 0;
			}
		}
	`}

	${$loading &&
    css `
		padding-right: calc(
			${SPINNER_SIZE} +
				(2 * ${pxToRem(Number(theme.spacing['200']) - Number(theme.borderWidth['2']) * 2)})
		);
	`}
`;
/**
 * @deprecated
 */
export const TextAreaContainer = styled(Typography).attrs({
    variant: 'field-text',
}) `
	${textareaContainerStyles}
`;
/**
 * Textarea Spinner
 * @deprecated
 */
export const textAreaSpinnerStyles = ({ theme }) => css `
	opacity: 1;
	position: absolute;
	top: ${pxToRem(theme.spacing[200])};
	right: ${pxToRem(theme.spacing[200])};

	${SpinnerSVG} {
		width: ${pxToRem(SPINNER_SIZE)};
		height: ${pxToRem(SPINNER_SIZE)};
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
/**
 * @deprecated
 */
export const TextAreaSpinner = styled(Spinner) `
	${textAreaSpinnerStyles}
`;
